<template>
  <div
    :style="getElementStyle"
    v-loading="loading"
    v-if="data.properties.filed_content != 'Hide'"
  >
    <el-row
      align="middle"
      v-if="
        !data.properties.hideLabel || data.properties.filed_content != 'Hide'
      "
    >
      <el-col
        :span="showLabel && !isDefalutPosq ? 4 : data.description ? 20 : 24"
        :style="computedStyles"
      >
        <label v-if="hasLabel && !data.properties.hideLabel">{{
          label || data.label
        }}</label>
        <span
          v-if="data.validations.required"
          style="color: red; font-weight: bold"
        >
          *
        </span>
        <span>
          <el-popover
            v-if="data.description"
            placement="top-start"
            trigger="hover"
            :content="data.description"
          >
            <i class="el-icon-info" slot="reference"></i>
          </el-popover>
        </span>
      </el-col>
    </el-row>
    <el-row type="flex" align="middle">
      <el-col :span="24">
        <div v-if="!isView" style="display: flex; align-items: center">
          <div v-if="data.integration_settings.allow_integration_quick_add">
            <quickIntegrationAddWidget
              :parentForm="form"
              :parentFields="fieldsData"
              :parentData="data"
              @callrefreshOptions="callingdatafromParent"
              :viewOrNot="isView"
              @matched-fields-found="handleMatchedFields"
              :dependencynotFilled="dependencyNotFilled"
            ></quickIntegrationAddWidget>
          </div>
          <div
            v-if="
              !data.integration_settings.selectedFormat ||
              data.integration_settings.selectedFormat == 'select'
            "
          >
            <el-select
              v-model="form[data.key]"
              :placeholder="data.placeholder || 'Select'"
              :suffix-icon="data.properties.el_icon"
              :style="combinedStyle"
              @change="handleSelectedValue"
              :disabled="checkReadonly()"
              @clear="handleClearIntegration()"
              clearable
              :filterable="true"
              :remote="true"
              :remote-method="searchOptions"
              :loading="localIsLoading"
            >
              <el-option
                v-if="
                  data.is_entity_field &&
                  form[data.key + '/name'] &&
                  form[data.key] &&
                  !optionRefresh
                "
                :label="form[data.key + '/name']"
                :value="form[data.key] ? form[data.key] : null"
              />
              <template v-if="!loading && this.options.length">
                <el-option
                  v-for="(option, index) in options"
                  :key="index"
                  :label="option[selectedColumnLabel]"
                  :value="option[selectedColumnKey]"
                />
              </template>
              <div
                v-if="hasMore && this.options.length >= 100"
                style="text-align: center"
              >
                <el-button
                  type="text"
                  :loading="localIsLoading"
                  @click="handleScroll"
                >
                  Load More...
                </el-button>
              </div>
            </el-select>
          </div>
          <div v-if="data.integration_settings.selectedFormat == 'input'">
            <el-input
              v-model="form[data.key]"
              clearable
              @clear="ClearThirdPartyData()"
              @input="handleInputValue"
              @input.native="emitIntegrationFieldEdited"
              :placeholder="data.placeholder || `Enter text`"
              :style="getStyle"
              @change="checkValidations()"
            />
            <p v-if="hasError" style="color: red; font-size: 14px">
              {{ errorMsg }}
            </p>
          </div>
          <span
            v-if="isActive || isDataTableField"
            class="setting-icon"
            @click="openSettings"
            style="margin-left: 8px"
          >
            <i class="el-icon-s-tools" />
          </span>
        </div>
        <div v-else style="margin-top: 5px">
          {{ form[selectedValue + "/name"] || form[selectedValue] }}
        </div>
      </el-col>
    </el-row>
  </div>
</template>
<script>
import { postAPICall } from "../../../helpers/httpHelper";
export default {
  components: {
    quickIntegrationAddWidget: () =>
      import("@/components/widgets/quickIntegrationAddWidget"),
  },
  props: [
    "data",
    "label",
    "value",
    "isActive",
    "isDataTableField",
    "isInDataTable",
    "form",
    "colorFields",
    "checkIsDisabled",
    "fromRepeatable",
    "fieldsData",
    "entityDataId",
    "entityId",
    "isHideField",
    "highlight",
    "fromEntityViews",
    "isView",
    "hasLabel",
    "integrationData",
    "integrationFieldValue",
    "triggeredIntegrationField",
    "labelAlignments",
    "integrations",
  ],
  computed: {
    selectedColumnLabel() {
      return this.data.integration_settings.selectedColumnLabel || "label";
    },
    selectedColumnKey() {
      return this.data.integration_settings.selectedColumnKey;
    },
    computedStyles() {
      const styles = {};
      styles.display = "flex";
      if (this.labelAlignments || this.data?.styles?.labelAlignments) {
        styles.justifyContent =
          this.labelAlignments || this.data?.styles?.labelAlignments;
      }
      return styles;
    },
    getStyle() {
      return {
        width: this.data?.width ? this.data.width + "px" : "100%",
        height: this.data?.height ? this.data.height - 30 + "px" : "auto",
      };
      // width:${this.data.width}px;overflow:auto;`
      // Tharuni Start
    },
    combinedStyle() {
      return {
        ...this.getStyle,
        flex: 1,
      };
    },
    getElementStyle() {
      let borderStyle = "";
      if (this.data.styles) {
        let type = this.data.styles.border_type
          ? this.data.styles.border_type
          : "solid";
        let size = this.data.styles.border_size
          ? this.data.styles.border_size + "px"
          : "0px";
        let color = this.data.styles.border_color
          ? this.data.styles.border_color
          : "";
        let font_size =
          this.data.styles &&
          this.data.styles.font &&
          this.data.styles.font.font_size
            ? this.data.styles.font.font_size
            : 14;
        let bold =
          this.data.styles &&
          this.data.styles.font &&
          (this.data.styles.font.style == 1 || this.data.styles.font.style == 3)
            ? "bold"
            : "";
        let italic =
          this.data.styles &&
          this.data.styles.font &&
          (this.data.styles.font.style == 2 || this.data.styles.font.style == 3)
            ? "italic"
            : "";

        borderStyle = "border:" + type + " " + " " + size + " " + color;

        borderStyle += ";";
        borderStyle += this.data.styles.background
          ? `background: ${this.data.styles.background}`
          : "";
        borderStyle += ";";
        borderStyle += "font-size:" + font_size + "px;";
        if (bold) {
          borderStyle += "font-weight:" + bold + ";";
        }
        if (italic) {
          borderStyle += "font-style:" + italic + ";";
        }
        borderStyle += this.data.styles.label_color
          ? `color: ${this.data.styles.label_color}`
          : "";
        borderStyle += ";";
      }
      return borderStyle;
    },

    isDefalutPosq() {
      if (this.data.styles && this.data.styles.labelStyle == "right") {
        return false;
      } else {
        return true;
      }
    },
    filteredOptions() {
      if (!this.options || this.options.length === 0) {
        return [];
      }
      if (!this.searchQuery) {
        return this.options;
      }
      return this.options.filter((option) =>
        option[this.selectedColumnLabel]
          .toLowerCase()
          .includes(this.searchQuery.toLowerCase())
      );
    },
  },
  data() {
    return {
      hasError: false,
      errorMsg: "",
      validations: [],
      options: [],
      showLabel: true,
      integrationsData: [],
      selectedValue: this.data.key,
      loading: false,
      previousValue: "",
      optionRefresh: false,
      limit: 100,
      localPage: 1,
      localIsLoading: this.isLoading,
      hasMore: true,
      fieldErrors: {},
      dependencyNotFilled: false,
      eventDataCache: {},
      loadingEvents: {},
      isLocalFilter: true,
      originalOptions: [],
      localIntegrations: {},
      isUserTyping: false,
    };
  },
  watch: {
    form: {
      async handler() {
        if (this.previousValue !== this.form[this.data.key]) {
          this.refreshOptions();
        }
      },
      deep: true,
    },
    integrationFieldValue: {
      async handler(newValue) {
        await this.handleFormChange(newValue);
      },
      deep: true,
    },
    integrations: {
      handler(newVal) {
        if (newVal && newVal.application) {
          setTimeout(() => {
            if (newVal.application.events) {
              this.getDetails();
            }
          }, 0);
        }
      },
      immediate: true,
      deep: true,
    },
  },
  async mounted() {
    if (!this.isView) {
      this.loading = true;
      if (this.form[this.data.key + "/name"]) {
        this.loading = false;
      }
      this.loading = false;
      await this.integrationDataUpdated();
      const currentValue = this.form[this.data.key];
      const currentName = this.form[`${this.data.key}/name`];
      // If there's a selected value and its label is missing
      if (currentName && this.isUserTyping) {
        await this.searchOptions(currentName);
        const match = this.options.find(
          (option) => option[this.selectedColumnKey] === currentValue
        );
        if (match) {
          this.$set(
            this.form,
            `${this.data.key}/name`,
            match[this.selectedColumnLabel]
          );
        }
      }
      if (!currentName && currentValue) {
        // await this.getDetails();
        const match = this.options.find(
          (option) => option[this.selectedColumnKey] === currentValue
        );
        if (match) {
          this.$set(
            this.form,
            `${this.data.key}/name`,
            match[this.selectedColumnLabel]
          );
        } else {
          this.$set(this.form, `${this.data.key}/name`, " ");
        }
      }
    }
    if (this.data.styles && this.data.styles.labelStyle) {
      if (this.data.styles.labelStyle == "hide") {
        this.showLabel = false;
      }
    }
  },
  methods: {
    emitIntegrationFieldEdited() {
      this.$emit("integrationFieldEdited", this.data.key);
    },
    handleInputValue(val) {
      this.isUserTyping = true;
      this.searchOptions(val);
      this.$set(this.form, `${this.data.key}/name`, val);
    },
    checkValidations() {
      if (
        this.data.properties.validations &&
        this.data.properties.validations.applyPattern
      ) {
        const regex = new RegExp(this.data.properties.validations.pattern);
        const isValid = regex.test(this.form[this.data.key]);
        this.hasError = true;
        this.errorMsg = !isValid
          ? this.data.properties.validations.patternMessage
          : "";
      }
    },
    ClearThirdPartyData() {
      this.form[this.data.key] = "";
      this.$set(this.form, `${this.data.key}/name`, "");
      this.$emit("integrationFieldEdited", this.data.key);
    },
    handleMatchedFields(matchedFields) {
      const matchedKeys = Array.isArray(matchedFields)
        ? matchedFields
        : [matchedFields];
      matchedKeys.forEach((matchedKey) => {
        const fieldInForm = this.fieldsData.find(
          (field) => field.key === matchedKey
        );
        const formValue = this.form[matchedKey];
        if (
          fieldInForm &&
          (formValue === undefined || formValue === null || formValue === "")
        ) {
          this.$notify.error({
            title: "Error",
            message: `Please select ${matchedKey} to add new ${this.data.label}`,
          });
          this.dependencyNotFilled = true;
        } else {
          this.dependencyNotFilled = false;
        }
      });
    },
    async callingdatafromParent(createdData) {
      let newItem = createdData.id;
      let newItemName = createdData.name || "Default Name";
      const exists = this.options.some(
        (option) => option[this.selectedColumnKey] === newItem
      );
      if (!exists) {
        this.options.unshift({
          [this.selectedColumnKey]: newItem,
          [this.selectedColumnLabel]: newItemName,
        });
      }
      this.$set(this.form, this.data.key, newItem);
      this.$set(
        this.form,
        `${this.data.key}/name`,
        this.options.find(
          (option) => option[this.selectedColumnKey] === newItem
        )?.[this.selectedColumnLabel] || "Default Name"
      );
      await this.integrationDataUpdated();
    },
    async searchOptions(query) {
      // if (this.isLocalFilter) {
      //   return;
      // }
      if (!query) {
        this.localPage = 1;
        this.options = [];
        return;
      }
      this.localIsLoading = true;
      let connection = this.data.integration_settings?.selectedIntegration;
      const selectedEventKey = this.data.integration_settings?.selectedEvent;
      const Event = this.integrations?.application?.events.find(
        (event) => String(event._id) === selectedEventKey
      );
      this.asset = Event?.asset;
      const requestBody = {
        selectedApplication: this.integrations?.application.key,
        selectedEvent: this.asset,
        selectedIntegration: connection,
        requiredFields: this.data.integration_settings?.requiredFields || {},
        limit: this.limit,
        page: this.localPage,
        searchQuery: query,
      };
      if (this.data.integration_settings.selectedFormat === "input") {
        return;
      }
      const apiResponse = await this.fetchEventData(requestBody);
      this.localIsLoading = false;
      if (apiResponse?.status === true) {
        if (this.localPage === 1) {
          this.options = apiResponse.data || [];
        } else {
          this.options = [...this.options, ...apiResponse.data];
        }
        this.hasMore = apiResponse.total > this.options.length;
      } else {
        this.options = [];
        this.hasMore = false;
      }
    },
    async handleScroll() {
      if (this.localIsLoading || !this.hasMore) return;
      this.localPage += 1;
      this.localIsLoading = true;
      const newData = await this.fetchNextPage();
      if (Array.isArray(newData) && newData.length) {
        this.options = newData;
      }
      this.localIsLoading = false;
    },
    async fetchNextPage() {
      let connection = this.data.integration_settings?.selectedIntegration;
      const selectedEventKey = this.data.integration_settings?.selectedEvent;
      const Event = this.integrations.application?.events?.find(
        (event) => String(event._id) === selectedEventKey
      );
      const asset = Event?.asset;
      const requestBody = {
        selectedApplication: this.integrations?.application.key,
        selectedEvent: asset,
        selectedIntegration: connection,
        requiredFields: this.data.integration_settings?.requiredFields || {},
        limit: this.limit,
        page: this.localPage,
      };
      const apiResponse = await this.fetchEventData(requestBody);
      return apiResponse?.status ? apiResponse.data || [] : [];
    },
    async handdleScroll() {
      let prevData;
      if (this.localIsLoading || !this.hasMore) return;
      this.localPage += 1;
      if (this.localPage !== 1) {
        prevData = this.options;
      }
      await this.getDetails();
      this.options = [...prevData, ...this.options];
      this.localIsLoading = false;
    },
    refreshOptions() {
      this.previousValue = this.form[this.data.key];
      this.optionRefresh = true;
      setTimeout(() => {
        this.optionRefresh = false;
      }, 100);
    },
    applyFormRules() {
      this.$emit("applyFormRules");
    },
    copyDocument() {
      this.$emit("copy-document", this.data.key);
    },
    openSettings() {
      this.$emit("settings");
    },
    async fetchEventData(requestBody) {
      try {
        const response = await postAPICall(
          "POST",
          "integrations/service/get-event-data",
          requestBody
        );
        return response.data;
      } catch (error) {
        return error;
      }
    },
    async getDetails() {
      let connection = this.data.integration_settings?.selectedIntegration;
      let dependencyConnection;
      if (
        !this.data.integration_settings?.templateDependencies ||
        (this.data.integration_settings?.templateDependencies &&
          this.data.integration_settings?.templateDependencies.length === 0)
      ) {
        const selectedEventKey = this.data.integration_settings?.selectedEvent;
        const Event = this.integrations.application?.events?.find(
          (event) => String(event._id) === selectedEventKey
        );
        const appKey = this.integrations.application.key;
        const asset = Event?.asset;
        const requestBody = {
          selectedApplication: appKey,
          selectedEvent: asset,
          selectedIntegration: connection,
          requiredFields: this.data.integration_settings?.requiredFields
            ? this.data.integration_settings.requiredFields
            : {},
          limit: this.limit,
          page: this.localPage,
        };
        if (this.data.integration_settings.selectedFormat === "input") {
          return;
        }
        this.loading = true;
        const apiResponse = await this.fetchEventData(requestBody);
        this.loading = false;
        if (apiResponse?.status === true) {
          this.options = apiResponse?.data || [];
          this.originalOptions = [...this.options];
          if (this.options.length === 1) {
            this.form[this.data.key] = this.options[0][this.selectedColumnKey];
            this.handleSelectedValue();
            this.hasMore = false;
          }
          const selectedValue = this.form[this.data.key];
          const matchedOption = this.options.find(
            (opt) => opt[this.selectedColumnKey] === selectedValue
          );
          if (matchedOption) {
            this.$set(
              this.form,
              this.data.key + "/name",
              matchedOption[this.selectedColumnLabel]
            );
          }
        } else {
          this.options = [];
          this.hasMore = false;
        }
      } else {
        let requiredFields = {};
        let macthedField;
        let templateDependencies =
          this.data.integration_settings?.templateDependencies;
        let filteredValues = templateDependencies.filter(
          (key) => this.form[key]
        );
        if (templateDependencies.length === filteredValues.length) {
          await templateDependencies.forEach((dependencyKey) => {
            macthedField = this.fieldsData.find(
              (field) => field.key == dependencyKey
            );
            if (macthedField) {
              let key = macthedField.integration_settings.selectedEvent;
              const Event = this.integrations?.application.events?.find(
                (event) => String(event._id) === key
              );
              const asset = Event?.asset;
              this.$set(requiredFields, asset, this.form[dependencyKey]);
            }
          });
          const event = this.integrations?.application.events.find(
            (event) =>
              String(event._id) === this.data.integration_settings.selectedEvent
          );
          dependencyConnection =
            this.findDependencyConnection(templateDependencies);
          if (!connection) {
            connection = dependencyConnection;
          }
          const requestBody = {
            selectedApplication: this.integrations?.application.key,
            selectedEvent: event.asset,
            selectedIntegration: connection,
            requiredFields: requiredFields,
          };
          if (macthedField.integration_settings.selectedFormat === "input") {
            return;
          }
          this.loading = true;
          const apiResponse = await this.fetchEventData(requestBody);
          this.loading = false;
          if (apiResponse.status === true) {
            this.options = apiResponse?.data || [];
            this.originalOptions = [...this.options];
            if (this.options.length === 1) {
              this.form[this.data.key] =
                this.options[0][this.selectedColumnKey];
              this.handleSelectedValue();
              this.hasMore = false;
            }
          } else {
            this.options = [];
            this.hasMore = false;
          }
        }
      }
    },
    async handleFormChange() {
      try {
        if (
          this.triggeredIntegrationField.length &&
          this.triggeredIntegrationField.includes(this.data.key)
        ) {
          const templateDependencies =
            this.data.integration_settings.templateDependencies;
          let requiredFields = {};
          let macthedField;
          let dependencyConnection;
          templateDependencies.forEach((dependencyKey) => {
            macthedField = this.fieldsData.find(
              (field) => field.key == dependencyKey
            );
            if (macthedField) {
              let key = macthedField.integration_settings.selectedEvent;
              const Event = this.integrations?.application.events?.find(
                (event) => String(event._id) === key
              );
              const asset = Event?.asset;
              this.$set(requiredFields, asset, this.form[dependencyKey]);
              dependencyConnection =
                this.findDependencyConnection(templateDependencies);
            }
          });
          let connection =
            macthedField.integration_settings.selectedIntegration;
          if (!connection) {
            connection = dependencyConnection;
          }
          const Event = this.integrations?.application.events.find(
            (e) =>
              String(e._id) === this.data.integration_settings.selectedEvent
          );
          const asset = Event?.asset;
          const requestBody = {
            selectedApplication: this.integrations.application.key,
            selectedEvent: asset,
            selectedIntegration: connection,
            requiredFields: requiredFields,
          };
          if (macthedField.integration_settings.selectedFormat === "input") {
            return;
          }
          this.loading = true;
          let apiResponse = await this.fetchEventData(requestBody);
          this.loading = false;
          this.$set(this.form, this.data.key, "");
          if (apiResponse.status === true) {
            this.options = apiResponse?.data || [];
            if (this.options.length === 1) {
              this.form[this.data.key] =
                this.options[0][this.selectedColumnKey];
              this.handleSelectedValue();
            }
          } else {
            this.options = [];
          }
        }
      } catch (err) {
        return err;
      }
    },
    findDependencyConnection(dependencies) {
      let connection = null;
      dependencies.forEach((key) => {
        const field = this.fieldsData.find((field) => field.key === key);
        if (field?.integration_settings?.selectedIntegration) {
          connection = field.integration_settings.selectedIntegration;
        } else {
          const anyConnectionField = this.fieldsData.find(
            (f) => f.input_type === "INTEGRATION"
          );
          if (anyConnectionField?.integration_settings?.selectedIntegration) {
            this.alternateConnection =
              anyConnectionField.integration_settings.selectedIntegration;
          }
        }
      });
      if (!connection) {
        connection = this.alternateConnection;
      }
      return connection;
    },
    handleClearIntegration() {
      this.clearedOptionSettings = this.data.integration_settings;
      let dependencyFields = this.fieldsData.filter(
        (field) =>
          field.integration_settings &&
          field.integration_settings.templateDependencies &&
          field.integration_settings.templateDependencies.includes(
            this.data.key
          )
      );
      dependencyFields.forEach((field) => {
        this.$set(this.form, field.key, "");
      });
      this.$set(this.form, this.data.key, null);
      this.integrationDataUpdated();
      this.getDetails();
    },
    handleSelectedValue() {
      this.applyFormRules();
      this.$emit(
        "integrationFieldValueUpdated",
        this.form[this.data.key],
        this.data
      );
      let value = this.options.find(
        (option) => option[this.selectedColumnKey] == this.form[this.data.key]
      );
      if (!value) {
        return;
      }
      this.$set(
        this.form,
        this.data.key + "/name",
        value[this.selectedColumnLabel]
      );
      this.$set(
        this.form,
        this.data.key +
          `/selectedAsset/${this.data.integration_settings.selectedAsset}`,
        value[this.selectedColumnLabel]
      );
      this.$set(
        this.form,
        "requiredField" + `/${this.data.integration_settings.selectedAsset}`,
        value[this.selectedColumnKey]
      );
      this.integrationDataUpdated();
    },
    async integrationDataUpdated() {
      let value = this.data.integration_settings.selectedColumnKey;
      this.selectedRecord = this.options.find(
        (option) => option[value] == this.form[this.data.key]
      );
      let neededData = this.integrations.application;
      let _changedIntegrationField = this.data.key;
      this.$emit(
        "integrationDataUpdated",
        this.selectedRecord,
        this.data,
        neededData,
        _changedIntegrationField
      );
    },
    readonly() {
      if (
        this.data &&
        this.data.properties &&
        this.data.properties.filed_content === "READ ONLY"
      ) {
        return true;
      }
    },
    checkReadonly() {
      if (this.checkIsDisabled) {
        return true;
      }
      if (
        this.data &&
        this.data.properties &&
        this.data.properties.filed_content === "DISABLED"
      ) {
        return true;
      }
      if (
        this.data &&
        this.data.properties &&
        this.data.properties.filed_content === "READ ONLY"
      ) {
        return true;
      }
    },
    filterOptions(filteredQuery) {
      if (!filteredQuery) {
        this.options = this.originalOptions || [];
        return;
      }
      if (
        !Array.isArray(this.originalOptions) ||
        this.originalOptions.length === 0
      ) {
        return;
      }
      this.options = (this.originalOptions || []).filter((option) => {
        const label = option[this.selectedColumnLabel];
        return (
          label && label.toLowerCase().includes(filteredQuery.toLowerCase())
        );
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.el-select {
  // width: 100% !important;

  .el-input,
  .el-input__inner {
    height: inherit !important;
  }
}
::v-deep .el-col-21 {
  width: 100% !important;
}
</style>
